import { useEffect } from "react";

const set = (name, content, attr = "name") => {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

/** Per-page title, description and canonical for SEO on the public marketing pages. */
export function useMeta({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    set("description", description);
    set("og:title", title, "property");
    set("og:description", description, "property");
    if (path) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = `https://plansarthi.com${path}`;
    }
  }, [title, description, path]);
}
